// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.page-number[data-v-064d3345] {\n  position: fixed;\n  bottom: 120px;\n  z-index: 999;\n}\n.prompt[data-v-064d3345] {\n  display: none;\n  padding: 3px 6px;\n  background-color: rgba(58, 58, 58, 0.7);\n  font-size: 12px;\n  color: white;\n  border-radius: 10px;\n  margin-bottom: 3px;\n}\n.page-number:hover .prompt[data-v-064d3345] {\n  display: inline-block;\n}\n", ""]);
// Exports
module.exports = exports;
